// Server flags control every user-facing entry point. Polling also covers
// updates handled by a different server worker than the SSE connection.
import { useEffect, useState } from 'react';
import axiosInstance from '../api/axios';

const HIDDEN = { ai_available: false, billing_visible: false, virenschutz_visible: false, pricing_visible: false };
export const VISIBILITY_CHANGED = 'io-visibility-changed';

export function useVisibilityFlags({ publicPricing = false } = {}) {
  const [flags, setFlags] = useState(HIDDEN);
  useEffect(() => {
    let active = true;
    let sequence = 0;
    let eventSource;
    const apply = data => {
      if (active) setFlags(Object.fromEntries(Object.keys(HIDDEN).map(key => [key, data?.[key] === true])));
    };
    const refresh = async () => {
      const request = ++sequence;
      try {
        const { data } = await axiosInstance.get(publicPricing ? '/app-config/pricing-visibility' : '/app-config/visibility', { headers: { 'Cache-Control': 'no-cache' } });
        if (active && request === sequence) apply(publicPricing ? { pricing_visible: data?.visible } : data);
      } catch {
        if (active && request === sequence) apply(HIDDEN);
      }
    };
    refresh();
    const interval = setInterval(refresh, 8000);
    const token = localStorage.getItem('token');
    if (!publicPricing && token && typeof EventSource !== 'undefined') {
      eventSource = new EventSource(`${process.env.REACT_APP_BACKEND_URL || ''}/api/app-config/stream?token=${encodeURIComponent(token)}`);
      eventSource.onmessage = event => {
        try { const data = JSON.parse(event.data); ++sequence; apply(data); } catch { /* Ignore malformed events. */ }
      };
      eventSource.onerror = () => eventSource.close();
    }
    const onVisible = () => { if (document.visibilityState === 'visible') refresh(); };
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', refresh);
    window.addEventListener(VISIBILITY_CHANGED, refresh);
    return () => {
      active = false;
      clearInterval(interval);
      eventSource?.close();
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', refresh);
      window.removeEventListener(VISIBILITY_CHANGED, refresh);
    };
  }, [publicPricing]);
  return flags;
}
